import Loadable from "react-loadable";
import LoadingComponent from "../../commons/loader";

export default [
  {
    path: "/",
    exact: true,
    component: Loadable({
      loader: () => import("./pages/login"),
      loading: LoadingComponent
    })
  },
  {
    path: "/register",
    exact: true,
    component: Loadable({
      loader: () => import("./pages/register"),
      loading: LoadingComponent
    })
  },
  {
    path: "/forgot",
    exact: true,
    component: Loadable({
      loader: () => import("./pages/forgotPassword"),
      loading: LoadingComponent
    })
  }
];



// WEBPACK FOOTER //
// ./src/modules/auth/routes.js